import React from 'react';

// Styles
import {
	ContentWrapperStyled,
	CloseContainerStyled,
	ContentContainerStyled,
	MobileRemoteContainerStyled,
} from './SidePanel.styled';

import { CloseIconStyled } from '../../library/Icons.styled';
import {
	TitleStyled,
	MobileRemoteMessageStyled,
} from '../../library/Text.styled';

// Components
import SidePanelEntry from '../SidePanelEntry/SidePanelEntry';

const SidePanel = (props) => {
	const { setSidePanel, sidePanelIsOpen, currentSelected, isMobileLayout } =
		props;

	const closeSidePanel = () => {
		setSidePanel(false);
	};

	// Determine copy
	const amountCoursesCopy =
		currentSelected.type === 'location'
			? currentSelected.entry.related.length > 1
				? `${currentSelected.entry.related.length} courses at this location:`
				: '1 course at this location:'
			: '';

	// Only show message on mobile and when the course is remote
	const showRemoteMessage =
		isMobileLayout &&
		currentSelected.type === 'single' &&
		!currentSelected.containsGeolocation;

	// Display single entry
	const single = () => {
		return <SidePanelEntry entry={currentSelected.entry}></SidePanelEntry>;
	};

	// Display location and its entries
	const location = () => {
		return (
			<>
				{currentSelected.entry.related.map((entry, index) => (
					<SidePanelEntry key={index} entry={entry}></SidePanelEntry>
				))}
			</>
		);
	};

	return (
		<ContentWrapperStyled className={!sidePanelIsOpen ? 'closed' : ''}>
			{showRemoteMessage && (
				<MobileRemoteContainerStyled>
					<MobileRemoteMessageStyled>
						This is a distance learning course.
					</MobileRemoteMessageStyled>
				</MobileRemoteContainerStyled>
			)}
			<CloseContainerStyled>
				<TitleStyled className="color-white">{amountCoursesCopy}</TitleStyled>
				<figure
					onClick={() => {
						closeSidePanel();
					}}
				>
					<CloseIconStyled />
				</figure>
			</CloseContainerStyled>
			<ContentContainerStyled>
				{currentSelected.type === 'single' && single()}
				{currentSelected.type === 'location' && location()}
			</ContentContainerStyled>
		</ContentWrapperStyled>
	);
};

export default SidePanel;
